import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import Hero from '@/components/b2b/Hero';
import { ComponentWrapper, ContentWrapper, RevampContentWrapper } from '@/components/b2b/Landing/styles';
import { LandingDisplayProps } from '@/components/b2b/shared/types';

import { LandingGridWrapper } from './styles';

const LegacyLandingDisplay = ({
	Component,
	activeScreen,
	errorData,
	isSubmitting,
	name,
	onAuthSuccess,
	onScreenChange,
	partnerDetails,
	redeem,
	requestAccessCall,
	supportUrl,
	userAccessCode,
	setUserAccessCode,
	isRevampRedempFlow,
}: LandingDisplayProps) => {
	const showHero = activeScreen !== 'pathwaysSuccess';

	if (isRevampRedempFlow) {
		return (
			<RevampContentWrapper id={MAIN_CONTENT_ID}>
				<Hero
					activeScreen={activeScreen}
					logoUrl={partnerDetails?.logo_url}
					pageInfo={partnerDetails?.pageInfo}
					partnerId={partnerDetails?.id}
					partnerName={partnerDetails?.name}
					partnerSlug={partnerDetails?.slug}
					isRevampRedempFlow={isRevampRedempFlow}
				/>
				{Component && (
					<ComponentWrapper showHero={showHero} isRevampRedempFlow={isRevampRedempFlow}>
						<Component
							error={errorData}
							isSubmitting={isSubmitting}
							name={name}
							onScreenChange={onScreenChange}
							onSuccess={onAuthSuccess}
							partnerDetails={partnerDetails}
							redeem={redeem}
							requestAccessCall={requestAccessCall}
							supportUrl={supportUrl}
							userAccessCode={userAccessCode}
							setUserAccessCode={setUserAccessCode}
							isRevampRedempFlow={isRevampRedempFlow}
						/>
					</ComponentWrapper>
				)}
			</RevampContentWrapper>
		);
	}

	return (
		<>
			<ContentWrapper showHero={showHero}>
				{showHero && (
					<Hero
						activeScreen={activeScreen}
						logoUrl={partnerDetails?.logo_url}
						pageInfo={partnerDetails?.pageInfo}
						partnerId={partnerDetails?.id}
						partnerName={partnerDetails?.name}
					/>
				)}
				{Component && (
					<ComponentWrapper showHero={showHero}>
						<LandingGridWrapper allowOverflow id={MAIN_CONTENT_ID} el="main">
							<Component
								error={errorData}
								isSubmitting={isSubmitting}
								name={name}
								onScreenChange={onScreenChange}
								onSuccess={onAuthSuccess}
								partnerDetails={partnerDetails}
								redeem={redeem}
								requestAccessCall={requestAccessCall}
								supportUrl={supportUrl}
								userAccessCode={userAccessCode}
								setUserAccessCode={setUserAccessCode}
							/>
						</LandingGridWrapper>
					</ComponentWrapper>
				)}
			</ContentWrapper>
		</>
	);
};

export default LegacyLandingDisplay;
